export default __webpack_public_path__ + "static/33-6bc2cbcf9ac02cfe08031374b57d2f5a.jpg";